import { getCurrentInstance, ref } from 'vue'
import { pgMessageBox } from '../components/index'

export function useFormModify() {
  const { proxy } = getCurrentInstance()
  const currentRouter = proxy.$store.state.menuStore.currentRouter

  return {
    setFormModifyBy() {
      proxy.$store.commit('setFormModifyBy', currentRouter.id)
    },
    clearFormModifyBy() {
      proxy.$store.commit('clearFormModifyBy', currentRouter.id)
    },
  }
}

export function useFormModifyDialog(modifyTip) {
  const modifyFlag = ref(false)

  return {
    modifyFlag,
    setModifyFlag(val) {
      modifyFlag.value = val
    },
    //判断是否存在编辑过的数据未保存，不存在或确认放弃则返回false
    async checkModifyFlag() {
      if (modifyTip && modifyFlag.value) {
        const { onClose, type } = await new Promise((resolve) => {
          pgMessageBox({
            message: '有数据未保存，确认放弃当前页面？',
            beforeClose(onClose, type) {
              resolve({ onClose, type })
            },
          })
        })
        onClose()
        if (!type) {
          return true
        }
      }
      return false
    },
  }
}
